export default __webpack_public_path__ + "static/media/3d-face.91daa3d6.png";